import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-[38px] w-full rounded-[10px] border bg-[hsl(var(--surface-2))] px-3.5 py-2 text-[13px] text-foreground placeholder:text-muted-foreground/60 transition-all duration-150 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-[rgba(212,168,67,0.10)] focus-visible:border-[rgba(212,168,67,0.50)] disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      style={{ borderColor: 'var(--border-default)' }}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
